/**
 * Lumafye Ambient Effects
 * Soft floating teal/mint orbs — a calm, gentle atmosphere that matches
 * the bright pet-calm palette (recolored from the original warm-amber
 * "lighting store" particle effect).
 */

(function () {
  'use strict';

  function initParticles() {
    const canvas = document.getElementById('luma-particles');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let W, H, particles = [], animFrame;

    const COLORS = [
      'rgba(62, 142, 126,',    // brand teal
      'rgba(94, 168, 150,',    // mid mint-teal
      'rgba(140, 195, 175,',   // soft mint
      'rgba(180, 218, 202,',   // pale mint
      'rgba(251, 250, 247,',   // warm cream highlight
    ];

    function resize() {
      W = canvas.width  = window.innerWidth;
      H = canvas.height = window.innerHeight;
    }

    function randomBetween(a, b) { return a + Math.random() * (b - a); }

    function createParticle() {
      return {
        x:       randomBetween(0, W),
        y:       randomBetween(H * 0.2, H),   // start in lower 80%
        size:    randomBetween(1.6, 4.2),
        blur:    randomBetween(3, 8),          // soft glow radius — gives the "orb" quality
        speedY:  randomBetween(-0.22, -0.07),  // drift upward
        speedX:  randomBetween(-0.1, 0.1),     // gentle sway
        opacity: randomBetween(0.1, 0.5),
        fade:    randomBetween(0.0007, 0.0025),
        color:   COLORS[Math.floor(Math.random() * COLORS.length)],
        sway:    randomBetween(0.003, 0.011),
        swayAmp: randomBetween(0.3, 1.0),
        t:       Math.random() * Math.PI * 2,
      };
    }

    function initParticlePool() {
      particles = [];
      const count = Math.floor((W * H) / 26000); // slightly sparser than the original
      for (let i = 0; i < Math.min(count, 42); i++) {
        const p = createParticle();
        p.y = randomBetween(0, H);
        particles.push(p);
      }
    }

    function tick() {
      ctx.clearRect(0, 0, W, H);

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.t      += p.sway;
        p.x      += p.speedX + Math.sin(p.t) * p.swayAmp * 0.4;
        p.y      += p.speedY;
        p.opacity -= p.fade;

        if (p.opacity <= 0 || p.y < -20 || p.x < -20 || p.x > W + 20) {
          particles[i] = createParticle();
          continue;
        }

        ctx.save();
        ctx.shadowColor = p.color + Math.min(p.opacity + 0.2, 0.9).toFixed(3) + ')';
        ctx.shadowBlur = p.blur;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = p.color + p.opacity.toFixed(3) + ')';
        ctx.fill();
        ctx.restore();
      }

      animFrame = requestAnimationFrame(tick);
    }

    resize();
    initParticlePool();
    tick();

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        cancelAnimationFrame(animFrame);
        resize();
        initParticlePool();
        tick();
      }, 200);
    });
  }

  function init() {
    initParticles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
